module.exports = __webpack_public_path__ + "img/Unterschrift.097938df.png";